import React from "react";
import { useMediaQuery } from "react-responsive";

const Engdesignfeatures = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "2rem",
      backgroundColor: "#025261",
      color: "#fff",
      flexWrap: "wrap",
    },
    leftSide: {
      flex: 1,
      paddingRight: isMobile ? "0" : "2rem",
      paddingTop: isMobile ? "2rem" : "0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      order: isMobile ? 2 : 1,
    },
    rightSide: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: isMobile ? "0" : "1rem",
      order: isMobile ? 1 : 2,
    },
    header: {
      fontSize: isMobile ? "1.5rem" : "2rem",
      fontWeight: "bold",
      color: "white",
    },
    paragraph: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      margin: "1rem 0",
      textAlign: "justify",
    },
    list: {
      listStyleType: "none",
      paddingLeft: 0,
    },
    listItem: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      marginBottom: "0.5rem",
      display: "flex",
      alignItems: "flex-start",
    },
    arrow: {
      marginRight: "0.5rem",
      color: "#4CAF50",
      fontSize: isMobile ? "1.2rem" : "1.5rem",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: isMobile ? "100%" : "auto",
    },
    image: {
      width: isMobile ? "100%" : "90%",
      maxWidth: "900px",
      height: "auto",
      borderRadius: "8px",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.rightSide}>
        <div style={styles.imageContainer}>
          <img
            src="/image/studying-germany-mechanical-engineering.webp"
            alt="ERP Features"
            style={styles.image}
          />
        </div>
      </div>
      <div style={styles.leftSide}>
        <h2 style={styles.header}>
          Mechanical Engineering Design Solutions for Your Business
        </h2>
        <p style={styles.paragraph}>
          Our custom mechanical engineering design solutions are crafted to meet
          the specific needs of your industry. We collaborate closely with you
          to understand your product requirements, optimize designs for
          manufacturability, and ensure performance excellence throughout the
          product lifecycle. Whether you're in automotive, aerospace, consumer
          goods, or industrial applications, we provide the expertise and
          innovation needed to bring your designs to life.
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Tailored mechanical design
            solutions for product development
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Expertise in material selection
            and structural integrity
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Advanced CAD modeling, 3D
            simulations, and prototyping
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Optimized designs for
            manufacturing cost efficiency
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Collaboration to ensure
            functional and scalable product designs
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Engdesignfeatures;
